module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page6",
      "title": "6"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "chapter-title---IVP",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page7",
      "title": "7"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('div', [_c('div', {
    attrs: {
      "epub:type": "toc",
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "veryfirst"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/preface_ackn#_idTextAnchor001"
    }
  }, [_vm._v("Preface and Acknowledgments\t")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part1#_idTextAnchor016"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_c('b', [_vm._v("PART 1: The Story that Shapes Cruciform Worship")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch1#_idTextAnchor019"
    }
  }, [_vm._v("1 | The Stories that Transform (or Deform) Us and the World")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch1#_idTextAnchor020"
    }
  }, [_c('i', [_vm._v("The Narrative Background to Cruciform Worship")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch2#_idTextAnchor052"
    }
  }, [_vm._v("2 | The World that We Shape and the World that Shapes Us\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch2#_idTextAnchor053"
    }
  }, [_c('i', [_vm._v("The Transformative Power of Cruciform Worship")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part2#_idTextAnchor072"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_c('b', [_vm._v("PART 2: Cruciformation: Worship in the Way of the Cross")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch3#_idTextAnchor076"
    }
  }, [_vm._v("3 | An Introduction to Cruciformation")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch3#_idTextAnchor077"
    }
  }, [_c('i', [_vm._v("(or, Toward a Theology of “Family Resemblance”)")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4#_idTextAnchor106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 | Cruciform Knowledge\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4#_idTextAnchor107",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Encountering Christ Through Cruciform Worship")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5#_idTextAnchor169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 | Cruciform Perfection")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5#_idTextAnchor170",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Completion in Christ Through Cruciform Community")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6#_idTextAnchor269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 | An Apology for the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part3#_idTextAnchor314",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_c('b', [_vm._v("PART 3: Cruciform Counterculture")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch7#_idTextAnchor316",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 | Worship at the Karaoke Chapel")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch7#_idTextAnchor317",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("From Subculture of Sameness to Counterculture of Cruciformity")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch8#_idTextAnchor343",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 | How the Many Become One in Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch8#_idTextAnchor344",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("From Homogeneous Unit to Multicultural, Multigenerational, Countercultural Family")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch9#_idTextAnchor408",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 | Cultivating a Counterculture of Cruciform Worship")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch9#_idTextAnchor409",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Some Basic Principles, Paradigms, and Approaches")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part4#_idTextAnchor451",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_c('b', [_vm._v("PART 4: Interpersonal Cruciformity")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch10#_idTextAnchor452",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 | Introduction to Interpersonal Cruciformity")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch11#_idTextAnchor506",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 | Interpersonal Cruciformity in the Congregation")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch12#_idTextAnchor554",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 | Interpersonal Cruciformity Within the Pastoral Staff")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part5#_idTextAnchor613",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_c('b', [_vm._v("PART 5: Cruciform Liturgy")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch13#_idTextAnchor626",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 | The Liturgy of Cruciform Worship")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch13#_idTextAnchor627",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Cruciformation Through Liturgical Ideation")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch14#_idTextAnchor700",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 | The Cruciformational Prayers of the People")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch14#_idTextAnchor701",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Ideation Through Supplication")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch15#_idTextAnchor735",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 | The Cruciformational Preaching and Singing of the Word")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch15#_idTextAnchor736",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Ideation Through Proclamation and Melodic-Harmonic Incarnation")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch16#_idTextAnchor792",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 | Cruciformation Through Holy Communion")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch16#_idTextAnchor793",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Ideation Through Sacramental Participation")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part6#_idTextAnchor834",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sans"
  }, [_c('b', [_vm._v("PART 6: Cruciform Mission")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch17#_idTextAnchor842",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 | Cruciformission\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch17#_idTextAnchor843",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Reconciled Reconcilers")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#_idTextAnchor869",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author_index#_idTextAnchor1247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author Index")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/subject_index#_idTextAnchor1248",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Subject Index")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/scripture_index#_idTextAnchor1249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture Index")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/praise#_idTextAnchor1250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', {
    staticClass: "i"
  }, [_vm._v("Worship in the Way of the Cross")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author#_idTextAnchor1251",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreIVP#_idTextAnchor1252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page8",
      "title": "8"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 63
// module chunks = 0